import { useEffect } from 'react';

interface IUseKeyboardControl {
  spacePress: (index: number) => void;
  index: number;
}
export default function(props: IUseKeyboardControl) {
  // 注意index必须传过去，因为最终调用spacePress时会将index丢过去，没有这个依赖会导致传过去的代码里边的index一直是初始值
  const { spacePress, index } = props;
  useEffect(() => {
    window.addEventListener('keypress', bindKey);
    return () => window.removeEventListener('keypress', bindKey);
  }, [index]);

  const bindKey = function(e: KeyboardEvent) {
    const { code } = e;
    // 空格
    console.log(code);
    if (code === 'Space') {
      spacePress(index);
    }
  };
}
